const getters = {
  permission_routers: state => state.permission.routers,
  userInfo: state => state.user.userInfo,
  menuIds: state => state.user.menuIds,
  user: state => state.user.user,
  listItem:state => state.device.listItem,
  roles: state => state.user.roles,
}
export default getters
